import './utils/polyfill'
import './utils/sw'

import AutoBind from 'auto-bind'
import FontFaceObserver from 'fontfaceobserver/fontfaceobserver.standalone'
import Home from './pages/Home'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Scrollbar from 'smooth-scrollbar'
import DisableScrollPlugin from './components/DisableScrollPlugin'

class App {
  constructor () {
    AutoBind(this)
    gsap.registerPlugin(ScrollTrigger)
    Scrollbar.use(DisableScrollPlugin)

    // this.createScroll()
    this.page = new Home()
    this.page.create()
    this.addEventListeners()
    this.onResize()
    this.update()
  }

  /**
   * Methods.
   */

  /**
   * Loop.
   */
  update () {
    if (this.page) {
      this.page.update()
    }
    window.requestAnimationFrame(this.update)
  }

  /**
   * Events.
   */

  onResize () {
    window.requestAnimationFrame((_) => {
      if (this.page) {
        this.page.onResize()
      }
    })
  }

  /**
   * Listeners.
   */
  addEventListeners () {
    window.addEventListener('resize', this.onResize, { passive: true })
  }
}

const fontNeueHaas = new FontFaceObserver('Neue Montreal')

Promise.all([fontNeueHaas.load()])
  .then((_) => {
    window.APP = new App()
  })
  .catch((_) => {
    window.APP = new App()
  })

console.log(
  '%c Developed by ZN Studio https://znstudio.com.au/',
  'background: #FF5C00; color: #000000;'
)
